export interface Expo {
  id: string;
  name: string;
  shortName: string;
  city: string;
  country: string;
  dateRange: string;
  status: 'Active' | 'Upcoming' | 'Past';
  category: string;
  attendees: string;
  booths: number;
  halls: number;
  coverImage: string;
  description: string;
}

export const expos: Expo[] = [
  {
    id: 'expo-001',
    name: 'World Tech Summit 2026',
    shortName: 'WTS 2026',
    city: 'Dubai',
    country: 'UAE',
    dateRange: 'Mar 28 – Apr 2, 2026',
    status: 'Active',
    category: 'Technology',
    attendees: '85,000+',
    booths: 420,
    halls: 6,
    coverImage: 'https://readdy.ai/api/search-image?query=futuristic%20technology%20expo%20hall%20with%20glowing%20neon%20displays%20and%20modern%20exhibition%20booths%20in%20a%20massive%20convention%20center%20with%20crowds%20of%20people%20and%20dramatic%20lighting&width=800&height=400&seq=expo001&orientation=landscape',
    description: 'The premier global technology summit bringing together the world\'s leading innovators.'
  },
  {
    id: 'expo-002',
    name: 'MedTech Global Expo',
    shortName: 'MedTech 2026',
    city: 'Berlin',
    country: 'Germany',
    dateRange: 'Apr 15 – Apr 19, 2026',
    status: 'Upcoming',
    category: 'Healthcare',
    attendees: '52,000+',
    booths: 280,
    halls: 4,
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20medical%20technology%20exhibition%20hall%20with%20clean%20white%20displays%20advanced%20healthcare%20devices%20and%20professional%20attendees%20in%20bright%20convention%20space&width=800&height=400&seq=expo002&orientation=landscape',
    description: 'Where healthcare innovation meets cutting-edge medical technology.'
  },
  {
    id: 'expo-003',
    name: 'Sustainable Future Expo',
    shortName: 'SFE 2026',
    city: 'Amsterdam',
    country: 'Netherlands',
    dateRange: 'May 5 – May 10, 2026',
    status: 'Upcoming',
    category: 'Sustainability',
    attendees: '38,000+',
    booths: 190,
    halls: 3,
    coverImage: 'https://readdy.ai/api/search-image?query=green%20sustainable%20energy%20expo%20with%20solar%20panels%20wind%20turbines%20displays%20eco-friendly%20booths%20and%20natural%20light%20in%20modern%20glass%20exhibition%20hall&width=800&height=400&seq=expo003&orientation=landscape',
    description: 'Leading exhibition for green energy, sustainability and future-ready technologies.'
  },
  {
    id: 'expo-004',
    name: 'FinTech World Forum',
    shortName: 'FWF 2025',
    city: 'Singapore',
    country: 'Singapore',
    dateRange: 'Nov 18 – Nov 22, 2025',
    status: 'Past',
    category: 'Finance',
    attendees: '61,000+',
    booths: 310,
    halls: 5,
    coverImage: 'https://readdy.ai/api/search-image?query=financial%20technology%20conference%20hall%20with%20dark%20premium%20design%20screens%20showing%20charts%20cryptocurrency%20data%20and%20professional%20business%20people%20networking&width=800&height=400&seq=expo004&orientation=landscape',
    description: 'Global platform for financial technology, blockchain, and digital payments.'
  }
];
